/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Murambi 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Murambi": ["Agacyamo", "Agasharu", "Agatagara", "Akamashya", "Byimana", "Kabarondo", "Kabuga", "Kigote", "Kimironko", "Kiniga", "Mataba", "Ryampunga", "Urugarama"],
  "Nyamiyaga": ["Bweranyange", "Kabeza", "Kagenge", "Kiniga", "Runyinya"],
  "Rwankuba": ["Akarambo", "Akayenzi", "Ikinyaga", "Impanzi", "Nyagasambu", "Nyagatovu", "Umwiga", "Urugarama"],
  "Rwimitereri": ["Bushenyi", "Bweya", "Byimana", "Kibumba", "Kigote", "Kimondo", "Kinunga", "Nyakabanda", "Rugarama"]
};